import postExternalMotionSearch from '@cartwhl/common/api/postExternalMotionSearch';

import {
  MOTION_LIBRARY_PAGE_SIZE,
  toMotionLibraryDisplayItem,
  type MotionLibraryDisplayItem,
} from './assetLibraryMotionLibrary';

export type MotionLibraryPageResult = {
  items: MotionLibraryDisplayItem[];
  hasMore: boolean;
  lastSort?: [number, string];
};

export async function fetchMotionLibraryPage(input: {
  apiKey: string;
  searchTerm: string;
  lastSort?: [number, string];
  signal: AbortSignal;
}): Promise<MotionLibraryPageResult> {
  const { data, error } = await postExternalMotionSearch(
    input.apiKey,
    {
      pageSize: MOTION_LIBRARY_PAGE_SIZE,
      ...(input.searchTerm ? { searchTerm: input.searchTerm } : {}),
      ...(input.lastSort ? { searchAfter: input.lastSort } : {}),
    },
    input.signal,
  );

  if (error) {
    throw new Error(error.message || 'Unable to load motion library.');
  }

  return {
    items: (data?.items ?? []).map(toMotionLibraryDisplayItem),
    hasMore: data?.hasMore ?? false,
    lastSort: data?.lastSort,
  };
}
